import * as tslib_1 from "tslib";
import { observable, action, computed } from 'mobx';
import { todayString } from '../utils/dates';
import DragDropPolicy from '../services/DragDropPolicy';
import TaskApi from '../services/TaskApi';
import { TimeItem } from './TimeItem';
import CheckListItem from './CheckListItem';
import TimeItemCollection from './TimeItemCollection';
import { Note } from './Note';
import store from 'src/store';
import TaskNoteApi from 'src/services/TaskNoteApi';
import { TaskStatuses } from './TaskStatus';
import { TASK_UPDATE_HUB } from 'src/services/Hubs';
import { blue500 } from 'material-ui/styles/colors';
var Task = /** @class */ (function () {
    function Task(dto) {
        this.relatives = [];
        this.id = dto.id;
        this.own = dto.own;
        this.userName = dto.userName;
        this.responsible = dto.responsible;
        this.closed = dto.closed;
        this.userId = dto.userId;
        this.headId = dto.headId;
        this.projectId = dto.projectId;
        this.project = dto.projectName;
        this.statusId = dto.statusId;
        this.competencyId = dto.competencyId;
        this.title = dto.title;
        this.deadline = dto.deadline;
        this.begin = dto.begin;
        this.end = dto.end;
        this.percentage = dto.percentage || 0;
        this.description = dto.description || '';
        this.competency = dto.competency;
        this.isReserve = dto.isReserve;
        this.plannedDuration = dto.plannedDuration;
        this.orderNo = dto.orderNo;
        this.stepName = dto.stepName;
        this.partnerName = dto.partnerName;
        this.product = dto.product;
        this.taskType = dto.taskType;
        this.taskSubType = dto.taskSubType;
        this.ticketPriority = dto.ticketPriority;
        this.priority = dto.priority;
        this.ticketClass = dto.ticketClass;
        this.ticketType = dto.ticketType;
        this.times = new TimeItemCollection(dto.timeItems.map(function (i) { return new TimeItem(i); }));
        this.checkListItems = dto.checkListItems.map(function (i) { return new CheckListItem(i); });
        this.note = dto.note;
        this.notes = (dto.notes || []).map(function (i) { return new Note(i); });
        this.important = !!dto.important;
        this.overwork = !!dto.overwork;
        this.relatives = dto.relatives;
        this.externalCode = dto.externalCode;
        this.sprintId = dto.sprintId;
        this.workerStatus = dto.workerStatus;
        this.partObjectID = dto.partObjectID;
        this.priorityColor = dto.priorityColor || blue500;
        this.offerCode = dto.offerCode;
        this.testDocumentationNeeded = dto.testDocumentationNeeded;
        this.insertUser = dto.insertUser;
        this.partnerNote = dto.partnerNote;
        this.noteTemplate = dto.noteTemplate;
        this.rating = dto.rating;
        this.projectCode = dto.projectCode;
        this.calculation = dto.calculation;
        this.developmentMode = dto.developmentMode;
        this.modifiedDeadline = dto.modifiedDeadline;
        this.plannedStart = dto.plannedStart;
        this.plannedEnd = dto.plannedEnd;
        this.productID = dto.productID;
        this.productCode = dto.productCode;
        this.tagCloud = dto.tagCloud;
    }
    Object.defineProperty(Task.prototype, "isReadonly", {
        get: function () {
            return (this.statusId === TaskStatuses.Backlog || this.closed);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "taskDeadline", {
        get: function () {
            return !!this.deadline && this.ticketClass.toLowerCase().includes('fix')
                ? new Date(this.modifiedDeadline || this.deadline)
                : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "sumDuration", {
        get: function () {
            return this.times.timeSpent();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "progress", {
        get: function () {
            return this.plannedDuration > 0 ? this.sumDuration / this.plannedDuration * 100 : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "hasCheckList", {
        get: function () {
            return this.checkListItems && this.checkListItems.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "dateString", {
        get: function () {
            return todayString(new Date(this.end));
        },
        enumerable: true,
        configurable: true
    });
    Task.prototype.canDrag = function () {
        var policy = DragDropPolicy.getCurrent();
        return policy.canDrag(this);
    };
    Task.prototype.canDrop = function (statusId) {
        var policy = DragDropPolicy.getCurrent();
        return policy.canDrop(this, statusId);
    };
    Task.prototype.setStatus = function (statusId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var task, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        task = Object.assign({}, this, { statusId: statusId });
                        return [4 /*yield*/, TaskApi.updateStatus(task)];
                    case 1:
                        response = _a.sent();
                        if (!response.succeeded) {
                            store.userStore.notify(response.message);
                            return [2 /*return*/];
                        }
                        this.statusId = statusId;
                        if (!(store.taskStore.lastTaskStatus === statusId)) return [3 /*break*/, 3];
                        this.setPercentage(100);
                        return [4 /*yield*/, this.updatePercentage()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        TASK_UPDATE_HUB.send(this.id);
                        return [2 /*return*/];
                }
            });
        });
    };
    Task.prototype.setPercentage = function (percentage) {
        this.percentage = percentage;
    };
    Task.prototype.setRating = function (rating) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.rating = rating;
                        return [4 /*yield*/, TaskApi.updateRating(this)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Task.prototype.setDescription = function (description) {
        this.description = description;
    };
    Task.prototype.updatePercentage = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, TaskApi.updatePercentage(this)];
                    case 1:
                        _a.sent();
                        TASK_UPDATE_HUB.send(this.id);
                        return [2 /*return*/];
                }
            });
        });
    };
    Task.prototype.setTimeOn = function (day, duration, note) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.times.removeAllOn(day)];
                    case 1:
                        _a.sent();
                        if (duration === 0) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.times.add({
                                userItemId: this.id,
                                userId: this.userId,
                                headId: this.headId,
                                date: day,
                                note: note,
                                duration: duration,
                            })];
                    case 2:
                        _a.sent();
                        TASK_UPDATE_HUB.send(this.id);
                        return [2 /*return*/];
                }
            });
        });
    };
    Task.prototype.addNote = function (userId, text) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var created;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, TaskNoteApi.create({
                            headId: this.headId,
                            userId: userId,
                            text: text
                        })];
                    case 1:
                        created = _a.sent();
                        if (created) {
                            this.notes = [created].concat(this.notes);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Task.prototype.updateNote = function (note, updateText) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var success;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, TaskNoteApi.update(note.id, {
                            headId: note.headId,
                            userId: note.userId,
                            text: updateText
                        })];
                    case 1:
                        success = _a.sent();
                        if (success) {
                            note.text = updateText;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Task.prototype.deleteNote = function (note) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var success;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, TaskNoteApi.delete(note.id)];
                    case 1:
                        success = _a.sent();
                        if (success) {
                            this.notes = this.notes.filter(function (i) { return i.id !== note.id; });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        observable
    ], Task.prototype, "description", void 0);
    tslib_1.__decorate([
        observable
    ], Task.prototype, "statusId", void 0);
    tslib_1.__decorate([
        observable
    ], Task.prototype, "percentage", void 0);
    tslib_1.__decorate([
        observable
    ], Task.prototype, "rating", void 0);
    tslib_1.__decorate([
        observable
    ], Task.prototype, "times", void 0);
    tslib_1.__decorate([
        observable
    ], Task.prototype, "checkListItems", void 0);
    tslib_1.__decorate([
        observable
    ], Task.prototype, "notes", void 0);
    tslib_1.__decorate([
        computed
    ], Task.prototype, "sumDuration", null);
    tslib_1.__decorate([
        computed
    ], Task.prototype, "progress", null);
    tslib_1.__decorate([
        computed
    ], Task.prototype, "hasCheckList", null);
    tslib_1.__decorate([
        action.bound
    ], Task.prototype, "setStatus", null);
    tslib_1.__decorate([
        action.bound
    ], Task.prototype, "setPercentage", null);
    tslib_1.__decorate([
        action.bound
    ], Task.prototype, "setRating", null);
    tslib_1.__decorate([
        action.bound
    ], Task.prototype, "setDescription", null);
    tslib_1.__decorate([
        action.bound
    ], Task.prototype, "updatePercentage", null);
    tslib_1.__decorate([
        action.bound
    ], Task.prototype, "setTimeOn", null);
    tslib_1.__decorate([
        action.bound
    ], Task.prototype, "addNote", null);
    return Task;
}());
export default Task;



//////////////////
// WEBPACK FOOTER
// ./src/models/Task.ts
// module id = 187
// module chunks = 0